import { render, staticRenderFns } from "./ScanPackCards.vue?vue&type=template&id=e35fafe6"
import script from "./ScanPackCards.vue?vue&type=script&lang=js"
export * from "./ScanPackCards.vue?vue&type=script&lang=js"
import style0 from "./ScanPackCards.vue?vue&type=style&index=0&id=e35fafe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports